export default "__VITE_ASSET__ecc7a989__"